module.exports = __webpack_public_path__ + "img/225.278952e3.png";